import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DropdownPoolOption from "components/Common/DropdownPoolOption";
import LabelWrapper from "components/Common/LabelWrapper";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Input, Label, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, Row, Spinner, TabContent, TabPane } from "reactstrap";
import { postSwap, postDeposit, getQuote, getPositionMint, getPoolTokenBalance, postWithdraw, getAllWallets } from "store/thunks";
import * as Yup from "yup";
import classnames from 'classnames';
import Nouislider from "nouislider-react";
import 'nouislider/distribute/nouislider.css';
import DropdownOption from "components/Common/DropdownOption";
import { LINK_FOR_NO_IMAGE } from "helpers/constans";
import { customToFixed } from "helpers/format";
export interface Props {
    isOpen?: boolean;
    detail?: any | null,
    listPool: any[],
    onClose?: () => void
    triggerRefresh?: (type?: string) => void;
}

const LiquidityForm = ({
    isOpen = false,
    detail = null,
    listPool = [],
    onClose,
    triggerRefresh
}: Props) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [activeTab, setActiveTab] = useState('1');

    const OPTION_POOLS = listPool;

    const [poolSelect, setPoolSelect] = useState<any>(null);

    const [listPositionMint, setListPositionMint] = useState<any>([]);

    const [listWallet, setListWallet] = useState<any[]>([]);

    const [tokenBalance, setTokenBalance] = useState<any>({});

    const [isLoadingPosition, setIsLoadingPosition] = useState<boolean>(false);

    const [isLoadingDetailPool, setIsLoadingDetailPool] = useState<boolean>(false);

    const SLIPPAGE_OPTIONS = [{ label: '0.0%', value: '0' }, { label: '0.3%', value: '0.003' }, { label: '0.5%', value: '0.005' }, { label: '1.0%', value: '0.01' }, { label: '2.0%', value: '0.02' }, { label: '3.0%', value: '0.03' }, { label: '4.0%', value: '0.04' }, { label: '5.0%', value: '0.05' }];

    const onCloseClick = () => {
        onClose && onClose();
        setPoolSelect(() => null);
        setListPositionMint(() => []);
        setActiveTab('1');
        setTokenBalance({});
        setListWallet([]);
        formik.resetForm();
    }
    const handleSubmit = async (values: any) => {
        try {
            setIsLoading((_prev) => true);
            const slippage = Number(values?.slippage?.value || SLIPPAGE_OPTIONS[2]?.value);
            const walletId = (values?.owner as any)?.value || '';
            const inputTokenMint = values?.type_input === 'a' ? poolSelect?.data?.tokenAddress1 : poolSelect?.data?.tokenAddress2;
            const inputTokenAmount = values?.type_input === 'a' ? Number(values?.amount_a) : Number(values?.amount_b);
            const inputTokenDecimals = values?.type_input === 'a' ? poolSelect?.data?.tokenDecimals1 : poolSelect?.data?.tokenDecimals2;
            const data = {
                pool: poolSelect?.value || '',
                walletId: Number(walletId),
                poolMint: values?.pool_mint?.value || '',
                inputTokenMint: inputTokenMint || '',
                inputTokenAmount: inputTokenAmount * Math.pow(10, Number(inputTokenDecimals)),
                slippage: slippage,

            };
            const response: any = values?.type_submit === 'DEPOSIT' ? await postDeposit(data) : await postWithdraw(data);
            if (response?.data) {
                setIsLoading((_prev) => false);
                toast(
                    <div>
                        {t("The process has been completed.")} -
                        <a href={`https://solscan.io/tx/${Array.isArray(response?.data) ? response?.data?.[0] : (response?.data || '')}`} className="text-primary text-decoration-underline" target="_blank" rel="noopener noreferrer">TX</a>
                    </div>,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                onCloseClick();
                // triggerRefresh && triggerRefresh();
            } else {
                setIsLoading((_prev) => false);
                toast(`${response || 'Error - Plz try again!'}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || 'Error - Plz try again!'}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        auto_swap: Yup.number().required(`${t("This is required")}`),
        amount_a: Yup.string().required(`${t("This is required")}`),
        amount_b: Yup.string().required(`${t("This is required")}`),
        min_cost: Yup.number().nullable(),
        max_cost: Yup.number().nullable(),
        quote: Yup.number().required(`${t("This is required")}`),
        type_input: Yup.string().required(`${t("This is required")}`),
        owner: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).required(`${t("This is required")}`),
        pool_mint: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).required(`${t("This is required")}`),
        type_submit: Yup.string().required(`${t("This is required")}`),
        slippage: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).nullable(),

        // aTob: Yup.boolean().nullable(),
        // sqrtPriceStr: Yup.string().required(`${t("This is required")}`),
    });

    const formik = useFormik({
        initialValues: {
            auto_swap: 0,
            quote: 0,
            type_input: 'a',
            amount_a: 0,
            amount_b: 0,
            min_cost: 0,
            max_cost: 40,
            pool_mint: null,
            type_submit: 'DEPOSIT', // WITHDRAW
            slippage: SLIPPAGE_OPTIONS[2],
            owner: null,
            // aTob: false,
            // sqrtPriceStr: ''
        },
        validationSchema,
        onSubmit: handleSubmit,
    });

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                const _amount_a = detail?.amount_a || '';
                const _amount_b = detail?.amount_b || '';

                const _min_cost = detail?.min_cost || 0;
                const _max_cost = detail?.max_cost || 40;

                const _quote = detail?.quote || 0;

                const _type_input = detail?.type_input || 'a';

                const _pool_mint = detail?.pool_mint || null;

                const _type_submit = detail?.type_submit || 'DEPOSIT';

                const _slippage = SLIPPAGE_OPTIONS[2];

                formik.setFieldValue('amount_a', _amount_a);
                formik.setFieldValue('amount_b', _amount_b);

                formik.setFieldValue('min_cost', _min_cost);
                formik.setFieldValue('max_cost', _max_cost);

                formik.setFieldValue('quote', _quote);

                formik.setFieldValue('type_input', _type_input);

                formik.setFieldValue('pool_mint', _pool_mint);

                formik.setFieldValue('type_submit', _type_submit);

                formik.setFieldValue('slippage', _slippage);

                setTimeout(() => {
                    formik.setErrors({});
                }, 300);
            } catch (error: any) {
                // setIsLoadingDetail((_prev) => false);
                return error;
            }
        };
        handleCallAllOption();
    }, [JSON.stringify(detail)]);


    // const handleChangeAtoB = () => {
    //     if (!poolSelect?.value) {
    //         return;
    //     }
    //     setPoolSelect((_prev: any) => {
    //         formik.setFieldValue('sqrtPriceStr', Boolean(!_prev?.data?.aTob) ? ORCA_MIN_SQRT_PRICE_X64 : ORCA_MAX_SQRT_PRICE_X64);
    //         return ({
    //             ..._prev,
    //             data: {
    //                 ..._prev?.data,
    //                 aTob: !_prev?.data?.aTob,
    //             }
    //         });
    //     });
    // };

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                setIsLoadingDetailPool(true);
                const data_param = {
                    owner: (formik?.values?.owner as any)?.label || '',
                    pool: poolSelect?.value || ''
                };
                const [res1, res2, res3]: any = await Promise.all([getQuote({ pair: poolSelect?.value }), getPositionMint(data_param), getPoolTokenBalance(data_param)]);
                setIsLoadingDetailPool(false);
                const positions = (res2?.data || [])?.map((_mint: string) => ({ label: _mint, value: _mint }));
                setListPositionMint((_prev: any) => positions);
                setTokenBalance((_prev: any) => res3?.tokens || {});
                formik.setFieldValue('quote', Number(res1?.data || 0));
                formik.setFieldValue('amount_a', Number(0));
                formik.setFieldValue('amount_b', Number(0));
                formik.setFieldValue('pool_mint', positions[0] || null);
            } catch (error: any) {
                setIsLoadingDetailPool(false);
                // setIsLoadingDetail((_prev) => false);
                return error;
            }
        };
        if (!!poolSelect?.value && !!(formik?.values?.owner as any)?.value) {
            handleCallAllOption();
        }
    }, [JSON.stringify(poolSelect?.value), formik?.values?.owner]);

    const handleReloadListPositionMint = async () => {
        try {
            if (!poolSelect?.value || !(formik?.values?.owner as any)?.value) {
                return;
            }
            setIsLoadingPosition(true);
            const data_param = {
                owner: (formik?.values?.owner as any)?.label || '',
                pool: poolSelect?.value || ''
            };
            const [res1]: any = await Promise.all([getPositionMint(data_param)]);
            setIsLoadingPosition(false);
            const positions = (res1?.data || [])?.map((_mint: string) => ({ label: _mint, value: _mint }));
            setListPositionMint((_prev: any) => positions);
            formik.setFieldValue('pool_mint', positions[0] || null);
        } catch (error: any) {
            setIsLoadingPosition(false);
            // setIsLoadingDetail((_prev) => false);
            return error;
        }
    };


    const toggleTab = (tab: any) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    useEffect(() => {
        const handleCallAllOption = async () => {
            const response: any = await getAllWallets();
            const _listWallet = response?.data?.map((_item: any) => ({ label: _item?.wallets?.pubkey, value: _item?.wallets?.ID }));
            setListWallet((_prev: any) => _listWallet);
        };
        if (!!isOpen) {
            handleCallAllOption();
        }
    }, [isOpen]);


    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="md"
                // className={`border-header-footer`}
                scrollable={false}
                toggle={onCloseClick}
                keyboard={true}
            >
                <ModalHeader toggle={onCloseClick} className="modal-title-flex-grow-1 pb-3 border border-dashed border-end-0 border-start-0 border-top-0">
                    <div className="d-flex flex-column gap-0 gap-sm-2 fs-18 fs-md-20">
                        <div className="flex-grow-1">
                            <>{t('Liquidity')}</>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative">
                    <div>
                        <form onSubmit={formik.handleSubmit}>
                            <Row>
                                <Col sm={12}
                                    md={6}
                                    xl={12}
                                    xxl={12}
                                    className="mt-2 mb-2"
                                >
                                    <div className="d-flex gap-3">
                                        <div className="flex-grow-1">
                                            <LabelWrapper label={t('Label_Pool')} isShow={true}>
                                                <DropdownPoolOption
                                                    isMultiLang
                                                    name="pool"
                                                    dataList={OPTION_POOLS}
                                                    initialValue={poolSelect || null}
                                                    onChangeSelect={(event: any) => {
                                                        setPoolSelect((_prev: any) => event);
                                                        formik.setFieldValue('address_from', event?.data?.tokenAddress1 || '');
                                                        formik.setFieldValue('address_to', event?.data?.tokenAddress2 || '');
                                                    }}
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    isShowMore={true}
                                                    // className="bg-[#fff]"
                                                    labelTop=""
                                                    isHasOptionAll={true}
                                                    optionAll={{
                                                        label: t('None'),
                                                        value: ''
                                                    }}
                                                    disabled={isLoadingPosition}
                                                />
                                            </LabelWrapper>
                                        </div>
                                        <div style={{ width: '100px' }}>
                                            <LabelWrapper label={t('Slippage')} isShow={true}>
                                                <DropdownOption
                                                    name="slippage"
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    dataList={SLIPPAGE_OPTIONS}
                                                    initialValue={formik?.values?.slippage || SLIPPAGE_OPTIONS[2]}
                                                    onChangeSelect={(event: any) => {
                                                        formik.setFieldValue('slippage', event);
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} lg={12} className="mt-2 mb-3">
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <LabelWrapper label={t('Wallet')} isShow={true}>
                                                <DropdownOption
                                                    name="owner"
                                                    dataList={listWallet}
                                                    placeholder={`${t('Wallet')}...`}
                                                    className="search-filter-category-type dropdown-status-rounded"
                                                    classNamePrefix="name-prefix"
                                                    initialValue={formik?.values?.owner || null}
                                                    onChangeSelect={(e: any) => formik.setFieldValue("owner", e)}
                                                    isHasOptionAll={true}
                                                    disabled={isLoadingPosition || isLoadingDetailPool}
                                                    optionAll={{ label: t('None'), value: '' }}
                                                />
                                            </LabelWrapper>
                                        </div>
                                    </div>
                                    {formik.touched.owner && formik.errors.owner ? (
                                        <div className="text-danger mt-2">{formik.errors.owner}</div>
                                    ) : null}
                                </Col>
                                <Col sm={12} lg={12} className="mt-2 mb-3">
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <LabelWrapper label={t('Position Mint')} isShow={true}>
                                                <DropdownOption
                                                    name="pool_mint"
                                                    dataList={listPositionMint}
                                                    placeholder={`${t('Position Mint')}...`}
                                                    className="search-filter-category-type dropdown-status-rounded"
                                                    classNamePrefix="name-prefix"
                                                    initialValue={formik?.values?.pool_mint || null}
                                                    onChangeSelect={(e: any) => formik.setFieldValue("pool_mint", e)}
                                                    isHasOptionAll={true}
                                                    optionAll={{ label: t('None'), value: '' }}
                                                    disabled={isLoadingPosition || isLoadingDetailPool}
                                                />
                                            </LabelWrapper>
                                        </div>
                                        <button
                                            type="button"
                                            className="ms-3  btn btn-secondary fs-14  bg-[#878a99] hover:bg-[#737582]"
                                            onClick={handleReloadListPositionMint}
                                            disabled={isLoadingPosition || isLoadingDetailPool || !formik?.values?.owner}
                                        >
                                            {(isLoadingPosition || isLoadingDetailPool) ? <span style={{ transform: 'translateY(1px)' }}><Spinner size="sm"></Spinner></span> : <i className="ri-refresh-line align-bottom"></i>}
                                        </button>
                                    </div>
                                    {formik.touched.pool_mint && formik.errors.pool_mint ? (
                                        <div className="text-danger mt-2">{formik.errors.pool_mint}</div>
                                    ) : null}
                                </Col>
                                <Col xxl={12}>
                                    <Card className="card-height-100 overflow-hidden">
                                        <CardHeader>
                                            <Nav className="nav-tabs-custom rounded card-header-tabs nav-justified border-bottom-0 mx-n3" role="tablist">
                                                <NavItem>
                                                    <NavLink
                                                        href="#"
                                                        className={classnames({ active: activeTab === '1', 'nav-link-warning': true })}
                                                        onClick={() => {
                                                            toggleTab('1');
                                                            formik.setFieldValue("type_submit", 'DEPOSIT');
                                                        }}
                                                    >
                                                        {t('Deposit')}
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        href="#"
                                                        className={classnames({ active: activeTab === '2', 'nav-link-warning': true })}
                                                        onClick={() => {
                                                            toggleTab('2');
                                                            formik.setFieldValue("type_submit", 'WITHDRAW');
                                                        }}
                                                    >
                                                        {t('Withdraw')}</NavLink>
                                                </NavItem>
                                            </Nav>
                                        </CardHeader>
                                        <CardBody className="p-0">
                                            <TabContent activeTab={activeTab} className="text-muted">
                                                <div className="p-3 bg-warning-subtle">
                                                    <div className="float-end ms-2">
                                                    </div>
                                                    <h6 className="mb-0 text-warning">{activeTab === '1' ? t('Deposit') : t('Withdraw')}</h6>
                                                </div>
                                                <div className="p-3">
                                                    <div>
                                                        <div className="input-group mb-3">
                                                            <Label className="input-group-text">Amount</Label>
                                                            <Input type="text" className="form-control fs-22" placeholder="0.0"
                                                                value={formik?.values?.amount_a}
                                                                onChange={(event: any) => {
                                                                    const input = event.target.value;
                                                                    const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                                                    const s = onlyNumbers;
                                                                    const quote = Number(formik?.values?.quote || 0);
                                                                    formik.setFieldValue("amount_a", s);
                                                                    formik.setFieldValue("amount_b", customToFixed(Number(s * quote), poolSelect?.data?.tokenDecimals2));
                                                                    formik.setFieldValue('type_input', 'a');
                                                                }}
                                                            />
                                                            <Label className="input-group-text" style={{ minWidth: '150px' }}>
                                                                <div className="d-flex flex-column w-100 align-items-end">
                                                                    <div className="d-flex justify-content-end align-items-end gap-1">
                                                                        <div className="text-center m-auto w-[24px]">
                                                                            <img
                                                                                src={poolSelect?.data?.logo1 || LINK_FOR_NO_IMAGE}
                                                                                style={{
                                                                                    width: "24px",
                                                                                    height: "24px",
                                                                                    borderRadius: "12px",
                                                                                }}
                                                                                className="flex-shrink-0 object-fit-cover m-auto w-[24px] h-[24px] !rounded-full"
                                                                                alt="token"
                                                                            />
                                                                        </div>
                                                                        <div className="fs-22 mb-0">
                                                                            {poolSelect?.data?.tokenSymbol1 || '***'}
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex justify-content-end align-items-end gap-1 text-muted">
                                                                        <i className="ri-wallet-3-line" />
                                                                        <span className="text-muted">
                                                                            {tokenBalance?.tokenA?.address === poolSelect?.data?.tokenAddress1 ? (
                                                                                tokenBalance?.tokenA?.balance?.uiAmount
                                                                            ) : (
                                                                                tokenBalance?.tokenB?.balance?.uiAmount
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </Label>
                                                        </div>

                                                        <div className="input-group mb-3">
                                                            <Label className="input-group-text">Amount</Label>
                                                            <Input type="text" className="form-control fs-22" placeholder="0.0"
                                                                value={formik?.values?.amount_b}
                                                                onChange={(event: any) => {
                                                                    const input = event.target.value;
                                                                    const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                                                    const s = onlyNumbers;
                                                                    const quote = Number(formik?.values?.quote || 0);
                                                                    const xx = quote === 0 ? 0 : (Number(s) / quote);
                                                                    formik.setFieldValue("amount_b", s);
                                                                    formik.setFieldValue("amount_a", customToFixed(Number(xx || 0), poolSelect?.data?.tokenDecimals1));
                                                                    formik.setFieldValue('type_input', 'b');
                                                                }}
                                                            />
                                                            <Label className="input-group-text" style={{ minWidth: '150px' }}>
                                                                <div className="d-flex flex-column w-100 align-items-end">
                                                                    <div className="d-flex justify-content-end align-items-end gap-1">
                                                                        <div className="text-center m-auto w-[24px]">
                                                                            <img
                                                                                src={poolSelect?.data?.logo2 || LINK_FOR_NO_IMAGE}
                                                                                style={{
                                                                                    width: "24px",
                                                                                    height: "24px",
                                                                                    borderRadius: "12px",
                                                                                }}
                                                                                className="flex-shrink-0 object-fit-cover m-auto w-[24px] h-[24px] !rounded-full"
                                                                                alt="token"
                                                                            />
                                                                        </div>
                                                                        <div className="fs-22 mb-0">
                                                                            {poolSelect?.data?.tokenSymbol2 || '***'}
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex justify-content-end align-items-end gap-1 text-muted">
                                                                        <i className="ri-wallet-3-line" />
                                                                        <span className="text-muted">
                                                                            {tokenBalance?.tokenB?.address === poolSelect?.data?.tokenAddress2 ? (
                                                                                tokenBalance?.tokenB?.balance?.uiAmount
                                                                            ) : (
                                                                                tokenBalance?.tokenA?.balance?.uiAmount
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </Label>
                                                        </div>
                                                    </div>
                                                    <div className="mt-3 pt-2">
                                                        <div className="d-flex mb-2">
                                                            <div className="flex-grow-1">
                                                                <p className="fs-13 mb-0">{t('New Position Balance')}</p>
                                                            </div>
                                                            <div className="flex-shrink-0">
                                                                <h6 className="mb-0">{t('Current')} <i className="ri-arrow-right-line text-muted fs-11" /> {t('New Balance')}</h6>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center mb-2">
                                                            <div className="">
                                                                <p className="fs-13 mb-0">
                                                                    <div className="d-flex justify-content-start align-items-end gap-1">
                                                                        <div className="text-center m-auto w-[20px]">
                                                                            <img
                                                                                src={(poolSelect?.data?.tokenAddress1 === tokenBalance?.tokenA?.address ? poolSelect?.data?.logo1 : poolSelect?.data?.logo2) || LINK_FOR_NO_IMAGE}
                                                                                style={{
                                                                                    width: "20px",
                                                                                    height: "20px",
                                                                                    borderRadius: "10px",
                                                                                }}
                                                                                className="flex-shrink-0 object-fit-cover m-auto w-[20px] h-[20px] !rounded-full"
                                                                                alt="token"
                                                                            />
                                                                        </div>
                                                                        <div className="fs-16 mb-0">
                                                                            {(poolSelect?.data?.tokenAddress1 === tokenBalance?.tokenA?.address ? poolSelect?.data?.tokenSymbol1 : poolSelect?.data?.tokenSymbol2) || '***'}
                                                                        </div>
                                                                    </div>
                                                                </p>
                                                            </div>
                                                            <div className="flex-shrink-0 flex-grow-1 text-end">
                                                                <h6 className="mb-0">{Number(tokenBalance?.tokenA?.balance?.uiAmount || 0)} <i className="ri-arrow-right-line text-muted fs-11" />  {Number(formik?.values?.amount_a || 0) + Number(tokenBalance?.tokenA?.balance?.uiAmount || 0)}</h6>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center mb-0">
                                                            <div className="">
                                                                <p className="fs-13 mb-0">
                                                                    <div className="d-flex justify-content-start align-items-end gap-1">
                                                                        <div className="text-center m-auto w-[20px]">
                                                                            <img
                                                                                src={(poolSelect?.data?.tokenAddress2 === tokenBalance?.tokenB?.address ? poolSelect?.data?.logo2 : poolSelect?.data?.logo1) || LINK_FOR_NO_IMAGE}
                                                                                style={{
                                                                                    width: "20px",
                                                                                    height: "20px",
                                                                                    borderRadius: "10px",
                                                                                }}
                                                                                className="flex-shrink-0 object-fit-cover m-auto w-[20px] h-[20px] !rounded-full"
                                                                                alt="token"
                                                                            />
                                                                        </div>
                                                                        <div className="fs-16 mb-0">
                                                                            {(poolSelect?.data?.tokenAddress2 === tokenBalance?.tokenB?.address ? poolSelect?.data?.tokenSymbol2 : poolSelect?.data?.tokenSymbol1) || '***'}
                                                                        </div>
                                                                    </div>
                                                                </p>
                                                            </div>
                                                            <div className="flex-shrink-0 flex-grow-1 text-end">
                                                                <h6 className="mb-0">{Number(tokenBalance?.tokenB?.balance?.uiAmount || 0)} <i className="ri-arrow-right-line text-muted fs-11" />  {Number(formik?.values?.amount_b || 0) + Number(tokenBalance?.tokenB?.balance?.uiAmount || 0)}</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mt-3 pt-2">
                                                        <button type="submit" disabled={!poolSelect?.value || isLoading || !(formik?.values?.pool_mint as any)?.value} className="btn w-100 btn-warning  bg-[#ffc107] hover:bg-[#d9a406]">
                                                            {isLoading && <span style={{ transform: 'translateY(1px)' }} className="me-1"><Spinner size="sm"></Spinner></span>}
                                                            {activeTab === '1' ? t('Deposit') : t('Withdraw')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </TabContent>
                                        </CardBody>
                                    </Card>
                                </Col>

                                <Col sm={12} className="mb-2 mt-3" >
                                    <div className="d-flex gap-3 justify-content-end align-item-center">
                                        <button
                                            className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center bg-[#878a99] hover:bg-[#737582]"
                                            type="button"
                                            onClick={onCloseClick}
                                            style={{ width: '75px' }}
                                        >
                                            <span className="ms-1">{t("Button Close")}</span>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment >
    );
};

export default LiquidityForm;

